import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {required} from "../../../components/elements/Forms/validations";
import {FormComponent} from "../../../components/elements/Forms/FormComponent";
import ContainerComponent from "../../../components/elements/ContainerComponent";
import * as Yup from 'yup';

export function CreateUser(props) {
  const {isView = false, isUpdate = false, item, retrieve, loader, user} = props;
  const [didMount, setDidMount] = useState(false)
  const nav = useNavigate();
  const {id} = useParams();

  useEffect(()=>{
    setDidMount(true);
  }, [])

  useEffect(() => {
    if (id && didMount){
      retrieve(id);
    }
  }, [id, retrieve, didMount]);

  const initialFields = {
    // photo: {label: 'Photo', type: 'imagen'},
    branch_office: {label: 'Sucursal',  validation: required(), type: 'select', urlOptionList : 'branch-offices/select' },
    role: {label: 'Rol', validation: required(), type: 'select', urlOptionList: 'role/select_option'},
    username: {label: 'Usuario', validation: required()},
    nit: {label: 'NIT', maxLength: '13'},
    dpi: {label: 'DPI', maxLength: '13',  type: 'number'},
    first_name: {label: 'Primer Nombre', validation: required()},
    second_name: {label: 'Segundo Nombre'},
    third_name: {label: 'Tercer Nombre'},
    last_name: {label: 'Primer Apellido', validation: required()},
    second_last_name: {label: 'Segundo Apellido'},
    department: {label: 'Departmaneto', type: 'select', urlOptionList: 'department/select_option'},
    municipality: {label: 'Municipio', type: 'select', urlOptionList: 'municipality/select_option', dependence: 'department'},
    address: {label: 'Dirección', validation: required()},
    phone_number: {label: 'Teléfono', type: 'number', maxLength: '8'},
    email: {label: 'Correo Electrónico', validation: required().email('Debe ingresar un correo valido')},
    birth_date: {
      type: 'date',
      label: 'Fecha de nacimiento',
      maxdate: new Date().setHours(new Date().getHours()),
      mindate: new Date().setMonth(new Date().getMonth() - (12 * 96)),
    },
  }

  const [fields, setFields] = useState(initialFields);

  const getSessionUserId = () => {
    return user?.id;
  };

  useEffect(() => {
    const isCreateUser = !isView && !isUpdate;
    const isCurrentUser = Number(id) === getSessionUserId();

    if (!isView && (isUpdate || isCreateUser)) {

      let passwordValidation = null;
      let passwordConfirmationValidation = null;

      if (isCreateUser) {
        passwordValidation = Yup.string()
          .required('La contraseña es requerida')
          .min(8, 'La contraseña debe tener al menos 8 caracteres');

        passwordConfirmationValidation = Yup.string()
          .required('La contraseña es requerida')
          .oneOf([Yup.ref('password'), null], 'Las contraseñas deben coincidir');

      } else if (isUpdate) {
        passwordValidation = Yup.string()
          .nullable()
          .test('password-validate', 'La contraseña debe tener al menos 8 caracteres', (value) => {
            return !(value && value.length < 8);
          });

        passwordConfirmationValidation = Yup.string()
          .nullable()
          .oneOf([Yup.ref('password'), null], 'Las contraseñas deben coincidir');
      }

      const fieldsWithPassword = {
        ...initialFields,
        password: {label: 'Contraseña', type: 'password', validation: passwordValidation},
        password_confirmation: {
          label: 'Vuelve a escribir la contraseña',
          type: 'password',
          validation: passwordConfirmationValidation
        },
      };

      if (isCurrentUser) {
        delete fieldsWithPassword.password;
        delete fieldsWithPassword.password_confirmation;
      }

      setFields(fieldsWithPassword);
    }
  }, []);

  const handleSubmit = (dataForm) => {
    dataForm.person && delete dataForm.person;
    const data = {
      person : {
        ...dataForm,
      },
      branch_office: dataForm.branch_office,
      role: dataForm.role,
      username: dataForm.username,
    }
    delete data.person.password_confirmation;
    delete data.person.branch_office;
    delete data.person.role;
    delete data.person.username;
    if(id){
      props.update(id, data, nav)
    } else {
      props.create(data, nav)
    }
  }
  return (
    <>
      <ContainerComponent
        title={isUpdate ? "Editar Usuario" : isView? `Usuario ${id}` : "Crear Usuario"}
      >
        {didMount && <FormComponent
          isUpdate={isUpdate}
          isView={isView}
          fields={fields}
          loader={loader}
          data={item? {...item, ...item.person}: {}}
          actionSubmit={handleSubmit}
          pathBack={'/usuario'}
        />}
      </ContainerComponent>
    </>
  )
}